import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LayoutsModule } from "./layouts/layouts.module";
// Auth
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";
import { environment } from "../environments/environment";
import { initFirebaseBackend } from "./authUtils";
import { FakeBackendInterceptor } from "./core/helpers/fake-backend";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
// Store
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { provideToastr, ToastrModule } from "ngx-toastr";
import { SharedModule } from "./shared/shared.module";
import { LoggerModule, NgxLoggerLevel } from "ngx-logger";
import { EffectsModule } from "@ngrx/effects";
import { DemandeAchatListEffects } from "./store/achat/demande-achat/demande-achat-list.effects";
import { rootReducer } from "./store";
import { JwtInterceptor } from "./core/helpers/jwt.interceptor";
import { DatePipe, registerLocaleData } from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import { ServiceWorkerModule } from '@angular/service-worker';
export function createTranslateLoader(http: HttpClient): any {
	return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

if (environment.defaultauth === "firebase") {
	initFirebaseBackend(environment.firebaseConfig);
} else {
	FakeBackendInterceptor;
}
registerLocaleData(localeFr);

@NgModule({
	declarations: [AppComponent],
	imports: [
		AppRoutingModule,
		HttpClientModule,
		BrowserModule,
		BrowserAnimationsModule,
		LayoutsModule,
		SharedModule,
		TranslateModule.forRoot({
			defaultLanguage: "fr",
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient],
			},
		}),
		StoreModule.forRoot(rootReducer),
		EffectsModule.forRoot([DemandeAchatListEffects]),

		ToastrModule.forRoot({ positionClass: "toast-bottom-center" }),
		LoggerModule.forRoot({
			level: NgxLoggerLevel.DEBUG,
			serverLogLevel: NgxLoggerLevel.ERROR,
		}),
		StoreDevtoolsModule.instrument({
			maxAge: 25,
			logOnly: environment.production,
		}),
  ServiceWorkerModule.register('ngsw-worker.js', {
    enabled: true,
    registrationStrategy: 'registerWhenStable:30000'
  }),
	],
	providers: [
		DatePipe,
		provideAnimations(),
		provideToastr(),
		{
			provide: HTTP_INTERCEPTORS,
			useClass: JwtInterceptor,
			multi: true,
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
